import sortBy from "lodash/sortBy";

export const getProjectsListFromProjects = (projects = [], user, includeAll = false) => {
  const userProjectIds = user?.projectIds || [];
  const filtered = projects.filter(
    project => project.active && userProjectIds.includes(project.id)
  );
  const sorted = sortBy(filtered, "name");
  return includeAll ? [{ id: "all", name: "All" }, ...sorted] : sorted;
};
